import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pascalCase' })
export class PascalCasePipe implements PipeTransform {
	transform(value: any): any {
		if (!value) {
			return '';
		} else {
			return value.replace(/(\w)(\w*)/g, function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })
		}
	}
}
